import { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { IGameFeedConfig } from 'js/components/system/App/store/types';
import { workerService } from 'js/services/worker.service';

export const useGetOldGamesFeeds = () => {
    const lang = useUserSelector(prop('lang'));
    const getCMSResourceURL = useGetCMSResourceURL();
    const {
        requestStamp,
        isOldGamesFeedsLoaded,
        oldGamesFeeds
    } = useAppSelector(pick([
        'requestStamp', 'isOldGamesFeedsLoaded', 'oldGamesFeeds'
    ]));

    return useCallback(async (disableCache?: boolean): Promise<IGameFeedConfig[] | undefined> => {
        if (!lang) {
            return;
        }

        if (isOldGamesFeedsLoaded && !disableCache) {
            return oldGamesFeeds;
        }

        const requestURL = getCMSResourceURL(`/initialResources/games/${lang}`, { t: requestStamp });

        return await workerService.request<{
            url: string;
        }, IGameFeedConfig[]>('gameFeeds', { url: requestURL });
    }, [
        isOldGamesFeedsLoaded,
        oldGamesFeeds,
        lang,
        requestStamp,
        getCMSResourceURL
    ]);
};
